import { jssPreset, StylesProvider } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { UIRouter } from "@uirouter/react";
import { enableMapSet } from "immer";
import { create, InsertionPoint } from "jss";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { router } from "./router";
import { store } from "./store";
import { AuthActions } from "./store/auth/actions";
import { AuthService } from "./store/auth/service";
import { theme } from "./theme";

Sentry.init({
  dsn: `https://${process.env.REACT_APP_SENTRY_KEY}@o1065215.ingest.sentry.io/${process.env.REACT_APP_SENTRY_ID}`,
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById(
    "jss-insertion-point"
  ) as InsertionPoint,
});

// Enable ImmerJS Plugins
enableMapSet();

AuthService.authenticated()
  .then((user) => {
    store.dispatch(AuthActions.authDone(user));
  })
  .catch((err) => Sentry.captureException(err))
  .finally(() => {
    ReactDOM.render(
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <StylesProvider jss={jss}>
              <UIRouter router={router}>
                <App />
              </UIRouter>
            </StylesProvider>
          </Provider>
        </ThemeProvider>
      </React.StrictMode>,
      document.getElementById("root")
    );
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
